import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

export function SpaceHistoryButton(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest | null;
}) {
    const { space, changeRequest } = props;

    return (
        <Button
            label="Version history"
            title={`View the history of changes made on this ${changeRequest ? 'change request' : 'space'}`}
            kind="blank"
            size="medium"
            iconOnly
            leadingIcon={Icon.History}
            href={{
                screen: {
                    type: 'space',
                    space: space.id,
                    organization: space.organization,
                    revision: changeRequest?.revision ?? space.revision,
                    sideSheet: undefined,
                    // Open in diff mode by default when viewing the history
                    mode: 'diff',
                },
            }}
        />
    );
}
